interface SupportPopoverItem {
  href: string;
  label: string;
  openInNewTab?: boolean;
}

export const helpSection: SupportPopoverItem[] = [
  {
    href: '/help',
    label: 'Help',
  },
  {
    href: '/contact',
    label: 'Contact',
  },
  {
    href: '/licensing',
    label: 'Licensing',
  },
];

export const legalSection: SupportPopoverItem[] = [
  {
    href: '/legal',
    label: 'Legal',
  },
  {
    href: '/terms',
    label: 'Terms of Use',
  },
  {
    href: '/privacy',
    label: 'Privacy Policy',
  },
];

export const affiliatesSection: SupportPopoverItem[] = [
  {
    href: 'https://feedback.kittl.com/feature-requests',
    label: 'Request Feature',
    openInNewTab: true,
  },
  {
    href: '/affiliates',
    label: 'Become Affiliate',
  },
];
